const BREAKPOINTS = {
	small:  { min: 0,    max: 768 },
	medium: { min: 769,  max: 1024 },
	large:  { min: 1025, max: 1299 },
	xlarge: { min: 1300, max: Infinity },
}

function currentBreakpoint() {
	const w = window.innerWidth
	for (const [name, range] of Object.entries(BREAKPOINTS)) {
		if (w >= range.min && w <= range.max) return name
	}
	return 'xlarge'
}

function apply(el, binding) {
	const value = binding.value || []
	const [action, ...visibleAt] = value
	const bp = currentBreakpoint()
	const matches = visibleAt.includes(bp)

	if (action === 'hidden-all') {
		el.style.display = matches ? '' : 'none'
	} else if (action === 'visibility-all') {
		el.style.visibility = matches ? '' : 'hidden'
	}
}

const listeners = new WeakMap()

export const Responsive = {
	mounted(el, binding) {
		apply(el, binding)
		const onResize = () => apply(el, binding)
		listeners.set(el, onResize)
		window.addEventListener('resize', onResize)
	},
	updated(el, binding) {
		apply(el, binding)
	},
	unmounted(el) {
		const onResize = listeners.get(el)
		if (onResize) {
			window.removeEventListener('resize', onResize)
			listeners.delete(el)
		}
	},
}

export default Responsive
